import { CALL_API } from '../middleware/ApiMiddleware';

export const PAYMENT_TYPE_CREATE_REQUEST = 'PAYMENT_TYPE_CREATE_REQUEST';
export const PAYMENT_TYPE_CREATE_FAILURE = 'PAYMENT_TYPE_CREATE_FAILURE';
export const PAYMENT_TYPE_CREATE_SUCCESS = 'PAYMENT_TYPE_CREATE_SUCCESS';

export const PAYMENT_TYPE_LIST_FETCH_REQUEST = 'PAYMENT_TYPE_LIST_FETCH_REQUEST';
export const PAYMENT_TYPE_LIST_FETCH_FAILURE = 'PAYMENT_TYPE_LIST_FETCH_FAILURE';
export const PAYMENT_TYPE_LIST_FETCH_SUCCESS = 'PAYMENT_TYPE_LIST_FETCH_SUCCESS';

export const PAYMENT_TYPE_FETCH_REQUEST = 'PAYMENT_TYPE_FETCH_REQUEST';
export const PAYMENT_TYPE_FETCH_FAILURE = 'PAYMENT_TYPE_FETCH_FAILURE';
export const PAYMENT_TYPE_FETCH_SUCCESS = 'PAYMENT_TYPE_FETCH_SUCCESS';

export const PAYMENT_TYPE_EDIT_REQUEST = 'PAYMENT_TYPE_EDIT_REQUEST';
export const PAYMENT_TYPE_EDIT_FAILURE = 'PAYMENT_TYPE_EDIT_FAILURE';
export const PAYMENT_TYPE_EDIT_SUCCESS = 'PAYMENT_TYPE_EDIT_SUCCESS';

export const PAYMENT_TYPE_LIST_EDIT_SEQUENCE_REQUEST = 'PAYMENT_TYPE_LIST_EDIT_SEQUENCE_REQUEST';
export const PAYMENT_TYPE_LIST_EDIT_SEQUENCE_SUCCESS = 'PAYMENT_TYPE_LIST_EDIT_SEQUENCE_SUCCESS';
export const PAYMENT_TYPE_LIST_EDIT_SEQUENCE_FAILURE = 'PAYMENT_TYPE_LIST_EDIT_SEQUENCE_FAILURE';

const baseURL = 'xerce/config/payment-types';

export const createPaymentType = (paymentType: IConfigXercePaymentTypeRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: paymentType,
    authenticated: true,
    types: [PAYMENT_TYPE_CREATE_REQUEST, PAYMENT_TYPE_CREATE_SUCCESS, PAYMENT_TYPE_CREATE_FAILURE],
  },
});

export const fetchPaymentTypes = () => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [PAYMENT_TYPE_LIST_FETCH_REQUEST, PAYMENT_TYPE_LIST_FETCH_SUCCESS, PAYMENT_TYPE_LIST_FETCH_FAILURE],
  },
});

export const fetchPaymentType = (paymentTypeId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${paymentTypeId}`,
    method: 'get',
    authenticated: true,
    types: [PAYMENT_TYPE_FETCH_REQUEST, PAYMENT_TYPE_FETCH_SUCCESS, PAYMENT_TYPE_FETCH_FAILURE],
  },
});

export const editPaymentType = (paymentTypeId: number, paymentType: IConfigXercePaymentTypeRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${paymentTypeId}`,
    method: 'put',
    body: paymentType,
    authenticated: true,
    types: [PAYMENT_TYPE_EDIT_REQUEST, PAYMENT_TYPE_EDIT_SUCCESS, PAYMENT_TYPE_EDIT_FAILURE],
  },
});

export const editPaymentTypeSequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/sequence`,
    method: 'put',
    body: { sequence },
    authenticated: true,
    types: [
      PAYMENT_TYPE_LIST_EDIT_SEQUENCE_REQUEST,
      PAYMENT_TYPE_LIST_EDIT_SEQUENCE_SUCCESS,
      PAYMENT_TYPE_LIST_EDIT_SEQUENCE_FAILURE,
    ],
  },
});
